import store from '@/store/store';
import Transformation from '../classes/transformation';
import { Project, SuccessResponse } from '../types';
import { ApiBaseService, ApiV2Service } from './api.base.service';

export interface SearchProjectsResponse {
  projects: Project[];
  columnFilters: any;
  total: number;
}

export class ProjectService {
  private apiV2: ApiBaseService;

  constructor() {
    this.apiV2 = ApiV2Service;
  }

  public async getListDetailsForProjectById(projectId: number) {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.get(`organisation/${organisation}/projects/${projectId}/details`);
  }

  public async getProjects(
    take: number = 0, skip: number = 0, sort: string = '',
    desc: boolean = false, filters: Record<string, Record<string, boolean>> = {},
    searchNames: string | null = null,
  ): Promise<SearchProjectsResponse> {
    let organisation = store.getters.activeOrganisation[0];
    if (!organisation) {
      await store.dispatch('addOrganisationsAsync');
    }
    organisation = store.getters.activeOrganisation[0].id;

    let filtersString: string = '';

    const filterQuery = Transformation.filterMapToQueryString(filters);

    if (filterQuery) {
      filtersString += `&${filterQuery}`;
    }

    if (searchNames) {
      filtersString += `&searchNames=${searchNames}`;
    }
    return this.apiV2.get(
      `organisation/${organisation}/projects?` +
      `take=${take}&skip=${skip}&sort=${sort}&desc=${desc}&includeColumnFilters=true${filtersString}`);
  }

  public async getProject(id: number): Promise<Project> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.get(`organisation/${organisation}/projects/${id}`);
  }

  public async getProjectsForOrganisation(organisationId: number): Promise<SearchProjectsResponse> {
    return this.apiV2.get(`organisation/${organisationId}/projects`);
  }

  public async createProject(details: object): Promise<Project> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.post(`organisation/${organisation}/projects`, details);
  }

  public async updateProject(id: number, payload: object): Promise<Project> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.put(`organisation/${organisation}/projects/${id}`, payload);
  }

  public async deleteProject(project: Project): Promise<SuccessResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.delete(`organisation/${organisation}/projects/${project.id}`);
  }

  public async addLocationsToProject(projectId: number, payload: any): Promise<SuccessResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.post(`organisation/${organisation}/projects/${projectId}/locations`, payload);
  }

  public async removeLocationFromProject(projectId: number, locationId: number): Promise<SuccessResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.delete(`organisation/${organisation}/projects/${projectId}/locations/${locationId}`);
  }
}

export default new ProjectService();
